<template>
  <v-dialog
      fullscreen
      :scrim="false"
      class="bg-overlay"
      transition="dialog-bottom-transition" id="mobileSearchModal" v-model="isActive">
      <v-card color="transparent">
        <v-toolbar color="white" height="74"   v-click-outside="closeSearchModal">
          <div class="w-100 p-3">
            <a  class="close-btn"  >
              <i class="far fa-times"></i>
            </a>
            <form class="cl-mobile-search">
              <label class="mobile-search-icon">
                <svg id="icon-search" width="100%" height="100%" viewBox="0 0 20 20">
                  <path d="M15.5,8.2c0-2.6-1.4-5-3.6-6.3s-5-1.3-7.2,0S1,5.7,1,8.2c0,4,3.2,7.2,7.2,7.2
                S15.5,12.3,15.5,8.2L15.5,8.2z M14,13.5l5,5L14,13.5z"></path>
                </svg>
              </label>
              <input type="text" @keydown.enter="showResultPage" :value="searchInput" @input="searchInput = $event.target.value" name="search"
                     placeholder="جست و جو دوره، پایه تحصیلی، استاد" autocomplete="off">
            </form>
          </div>
        </v-toolbar>
        <div class="">
          <ClLoadingOverlay v-if="isLoading" v-model="isLoading" />
          <div class="mobile-search-suggest-container" v-show="isActiveSearchContainer" ref="searchBoxContainer">
            <div v-if="hasSearchResult" class="search-suggest p-4" @click="deactivateOverly">
              <h2 v-if="searchResult.teachers.length">اساتید</h2>
              <router-link v-for="(teacher,index) in searchResult.teachers" :key="index"
                           :to="{name:'professor', params:{'userId': teacher.id }}">
                <img :src="menuProfImage(teacher.img)">
                <span>{{ teacher.name }}</span>
              </router-link>
              <h2 v-if="searchResult.courses.length">دوره‌ها</h2>
              <router-link v-for="(course,index) in searchResult.courses" :key="index"
                           :to="getLink(course)">
                <img :src="menuProductImage(course.img)">
                <span>{{ course.name }}</span>
              </router-link>
            </div>
            <div v-else  class=" mt-4 border-0 px-6">
              <span class="no-result">جستجو برای عبارت «{{ searchInput }}» نتیجه ای نداشت.</span>
            </div>
          </div>
        </div>
      </v-card>
  </v-dialog>
</template>

<script>
import ClLoadingOverlay from "@/components/base/ClLoadingOverlay.vue";
import RepositoryFactory from "@/repositories/RepositoryFactory";
// import ClModal from "@/components/common/ClModal.vue";

export default {
  components: {
    ClLoadingOverlay
    // ClModal,
  },
  props: ['activeSearchModal'],
  data() {
    return {
      isLoading: false,
      isActive: false,
      productSearchRepo: RepositoryFactory.get('ProductSearch'),
      isActiveSearchContainer: false,
      searchInput: '',
      searchResult: {},
      config: '',
      isFocus: false,
      topOffset: '0px',
      isSpinnerActive: false
    }
  },
  methods: {
    getLink(item) {
      let link = ''
      if (
        item.product_type_id !== 15 &&
        item.product_type_id !== 12 &&
        item.product_type_id !== 10
      ) {
        link = {
          name: 'course',
          params: {
            courseId: item.product_id,
            teacherId: item.teacher_id
          },
        }
      } else if (item.product_type_id === 15)
        link = { name: 'customPackage', params: { courseId: item.product_id } }
      else {
        link = { name: 'package', params: { courseId: item.product_id } }
      }
      return link
    },
    closeSearchModal(){
      this.isActive = false;
      this.$emit('mobileSearchBtnTrigger', false)
    },
    clearSearchInput() {
      this.searchInput = '';
      this.isActiveSearchContainer = false;
    },
    deactivateOverly() {
      this.isActiveSearchContainer = false;
    },
    showResultPage() {
      if (this.searchInput.length > 2) {
        this.isActive = false;
        this.$router.push({name: 'search', params: {term: this.searchInput}});
      }
      // window.location.href = '/site/search/' + this.searchInput;
    },

    menuProductImage(img) {
      return new URL(this.$storeFourBaseUrl +'/filepond/product/' + img, import.meta.url)
    },
    menuProfImage(img) {
      return new URL(this.$storeFourBaseUrl +'/filepond/profile/' + img, import.meta.url)
    }
  },
  watch: {
    activeSearchModal: {
      handler: function (value) {
        this.isActive = value;
      },
      immediate: true,
    },
    async searchInput(){
      if (this.searchInput.length > 2) {
        this.isActiveSearchContainer = true;
        this.isLoading = true;
        try {
          const {data} = await this.productSearchRepo.send({'keyword': this.searchInput});
          this.searchResult = data;
          this.isLoading = false
        } catch (error) {
          console.log(error)
        }
      } else {
        this.isActiveSearchContainer = false;
      }
    }
  },
  computed: {
    hasSearchResult() {
      return this.searchResult.courses?.length || this.searchResult.teachers?.length || this.searchResult.packages?.length
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.spinner-border {
  width: 1.5rem;
  height: 1.5rem;
}

.bg-overlay {
 background-color: rgba(255,255,255,0.6)!important;
}
</style>
